<template>
  <div class="home-main-left-register">
    <div class="register-form">
      <div class="form-item required">
        <div class="form-label">证件类型</div>
        <div class="form-input">
          <el-select v-model="registerForm.cardType" v-focus-caller>
            <el-option label="身份证" value="id"></el-option>
            <el-option label="护照" value="passport"></el-option>
            <el-option label="军官证" value="officer"></el-option>
            <el-option label="港澳台身份证" value="hongkong"></el-option>
          </el-select>
        </div>
      </div>
      <div class="form-item required">
        <div class="form-label">证件号码</div>
        <div class="form-input">
          <el-input type="text" v-model="registerForm.cardNo" v-focus-caller/>
        </div>
      </div>
      <div class="form-item required">
        <div class="form-label">注册方式</div>
        <div class="form-input">
          <el-radio-group v-model="registerForm.sendType" @input="changeSendType">
            <el-radio-button label="SMS"><i class="el-icon-mobile-phone form-icon"></i>短信</el-radio-button>
            <el-radio-button label="EMAIL"><i class="el-icon-message form-icon"></i>邮箱</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="form-item required" v-show="registerForm.sendType === 'SMS'">
        <div class="form-label">手机号码</div>
        <div class="form-input">
          <el-input type="text" v-model="registerForm.mobilePhone" v-focus-caller/>
        </div>
      </div>
      <div class="form-item required" v-show="registerForm.sendType === 'EMAIL'">
        <div class="form-label">邮箱</div>
        <div class="form-input">
          <el-input type="text" v-model="registerForm.email" v-focus-caller/>
        </div>
      </div>
      <div class="form-item required">
        <div class="form-label">图形验证码</div>
        <div class="form-input append">
          <el-input type="text" v-model="registerForm.authCode" v-focus-caller/>
          <div class="form-append">
            <div class="auth-img" :style="{'background-image': 'url(' + getContextPath(authImg.src + '?' + authImg.stamp) + ')'}" title="点击更换验证码" @click="reloadAuthImg"/>
          </div>
        </div>
      </div>
      <div class="form-item required">
        <div class="form-label">{{registerForm.sendType === 'SMS' ? '短信' : '邮箱'}}验证码</div>
        <div class="form-input append">
          <el-input type="text" v-model="registerForm.smsCode" v-focus-caller/>
          <div class="form-append">
            <el-button type="info" class="send-verification-btn" :disabled="registerVerification.committing || registerVerification.delay > 0" @click="sendRegisterVerification">{{registerVerification.delay > 0 ? registerVerification.delay + '秒后重发' : '获取验证码'}}</el-button>
          </div>
        </div>
      </div>
      <div class="form-item required">
        <div class="form-label">密码</div>
        <div class="form-input">
          <el-input type="password" v-model="registerForm.password" v-focus-caller/>
          <div class="hint-msg">
            <span>密码必须包含大小写字母和数字，长度8-20位</span>
          </div>
        </div>
      </div>
      <div class="form-item required">
        <div class="form-label">确认密码</div>
        <div class="form-input">
          <el-input type="password" v-model="registerForm.confirmPassword" v-focus-caller/>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button type="primary" class="submit-register-btn login-register-button-style" :disabled="registerForm.committing" @click="submitRegister">{{registerForm.committing ? '注册中...' : '立即注册'}}</el-button>
    </div>
    <div class="bottom-menu clearfix">
      <div class="forget-password">
        <router-link to="/forgetPassword">忘记密码？</router-link>
      </div>
      <div class="login">
        <span @click="handleToLogin">去登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import support from '../../../mixins/support'
import focusCaller from '../../../directives/focusCaller'
import checkNoUtils from '../../../util/checkNoUtils'
import inputRuleUtils from '../../../util/inputRuleUtils'

export default {
  name: 'HomeMainLeftRegister',
  mixins: [support],
  directives: {focusCaller},
  props: {
    currentNav: Number
  },
  data () {
    return {
      authImg: {
        src: '/index/authImg/homeIndexRegister',
        stamp: new Date().getTime()
      },
      registerForm: {
        cardType: '',
        cardNo: '',
        sendType: 'SMS',
        mobilePhone: '',
        email: '',
        authCode: '',
        smsCode: '',
        password: '',
        confirmPassword: '',
        committing: false
      },
      registerVerification: {
        delay: 0,
        timer: null,
        committing: false
      }
    }
  },
  methods: {
    handleToLogin () {
      this.$emit('update:currentNav', 0)
    },
    reloadAuthImg () {
      this.authImg.stamp = new Date().getTime()
    },
    validateCardNoByType (cardType, cardNo) {
      if (cardType === 'id') {
        return checkNoUtils.isValidIdCard(cardNo)
      }
      return true
    },
    refreshSmsSendDelay () {
      if (this.registerVerification.delay > 0) {
        this.registerVerification.timer = setTimeout(() => {
          this.registerVerification.delay--
          this.refreshSmsSendDelay()
        }, 1000)
      }
    },
    loadRegisterData () {
      this.$ajax({
        url: '/index/homeIndex/registerData',
        method: 'post',
        data: this.$qs.stringify({
          sendType: this.registerForm.sendType
        })
      }).then(response => {
        if (response.data) {
          let sendDelay = response.data['sendDelay']
          if (typeof sendDelay === 'number') {
            this.registerVerification.delay = sendDelay
          }
        }
      })
    },
    changeSendType (val) {
      this.registerForm.smsCode = ''
      if (val === 'SMS') {
        this.registerForm.email = ''
      } else {
        this.registerForm.mobilePhone = ''
      }
      this.loadRegisterData()
    },
    sendRegisterVerification () {
      let sendType = this.registerForm.sendType
      if (sendType === 'SMS') {
        let mobilePhone = this.registerForm.mobilePhone
        if (!mobilePhone) {
          this.$message.error('请输入手机号码')
          this.$emit('focus', 'registerForm.mobilePhone')
          return
        }
        if (!checkNoUtils.isValidMobilePhone(mobilePhone)) {
          this.$message.error('手机号码填写不合法')
          this.$emit('focus', 'registerForm.mobilePhone')
          return
        }
      } else if (sendType === 'EMAIL') {
        let email = this.registerForm.email
        if (!email) {
          this.$message.error('请输入邮箱')
          this.$emit('focus', 'registerForm.email')
          return
        }
        if (!inputRuleUtils.isValidEmail(email)) {
          this.$message.error('邮箱填写不合法')
          this.$emit('focus', 'registerForm.email')
          return
        }
      }
      let authCode = this.registerForm.authCode
      if (!authCode) {
        this.$message.error('请输入图形验证码')
        this.$emit('focus', 'registerForm.authCode')
        return
      }
      this.registerVerification.committing = true
      this.$ajax({
        url: '/index/homeIndex/registerVerification',
        method: 'post',
        data: this.$qs.stringify({
          sendType: sendType,
          mobilePhone: this.registerForm.mobilePhone,
          email: this.registerForm.email,
          authCode: authCode
        })
      }).then(response => {
        // 成功返回则要刷新验证码
        this.reloadAuthImg()
        // 处理返回结果
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              // 延时处理
              let sendDelay = response.data['sendDelay']
              if (typeof sendDelay === 'number') {
                this.registerVerification.delay = sendDelay
              }
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('获取验证码请求发送失败')
      }).finally(() => {
        this.registerVerification.committing = false
      })
    },
    submitRegister () {
      let cardType = this.registerForm.cardType
      if (!cardType) {
        this.$message.error('请先选择证件类型')
        this.$emit('focus', 'registerForm.cardType')
        return
      }
      let cardNo = this.registerForm.cardNo
      if (!cardNo) {
        this.$message.error('请输入证件号码')
        this.$emit('focus', 'registerForm.cardNo')
        return
      }
      if (!this.validateCardNoByType(cardType, cardNo)) {
        this.$message.error('证件号码填写不合法')
        this.$emit('focus', 'registerForm.cardNo')
        return
      }
      let sendType = this.registerForm.sendType
      if (sendType === 'SMS') {
        let mobilePhone = this.registerForm.mobilePhone
        if (!mobilePhone) {
          this.$message.error('请输入手机号码')
          this.$emit('focus', 'registerForm.mobilePhone')
          return
        }
        if (!checkNoUtils.isValidMobilePhone(mobilePhone)) {
          this.$message.error('手机号码填写不合法')
          this.$emit('focus', 'registerForm.mobilePhone')
          return
        }
      } else if (sendType === 'EMAIL') {
        let email = this.registerForm.email
        if (!email) {
          this.$message.error('请输入邮箱')
          this.$emit('focus', 'registerForm.email')
          return
        }
        if (!inputRuleUtils.isValidEmail(email)) {
          this.$message.error('邮箱填写不合法')
          this.$emit('focus', 'registerForm.email')
          return
        }
      }
      let smsCode = this.registerForm.smsCode
      if (!smsCode) {
        this.$message.error('请输入短信验证码')
        this.$emit('focus', 'registerForm.smsCode')
        return
      }
      let password = this.registerForm.password
      if (!password) {
        this.$message.error('请输入密码')
        this.$emit('focus', 'registerForm.password')
        return
      }
      if (!checkNoUtils.isValidPassword(password)) {
        this.$message.error('密码填写不合法（要求8-20位大小写字母和数字组合）')
        this.$emit('focus', 'registerForm.password')
        return
      }
      let confirmPassword = this.registerForm.confirmPassword
      if (!confirmPassword) {
        this.$message.error('请再次输入密码')
        this.$emit('focus', 'registerForm.confirmPassword')
        return
      }
      if (password !== confirmPassword) {
        this.$message.error('两次密码输入不一致')
        this.$emit('focus', 'registerForm.confirmPassword')
        return
      }
      this.registerForm.committing = true
      this.$ajax({
        url: '/index/homeIndex/submitRegisterData',
        method: 'post',
        data: this.$qs.stringify({
          cardType: cardType,
          cardNo: cardNo,
          sendType: sendType,
          mobilePhone: this.registerForm.mobilePhone,
          email: this.registerForm.email,
          smsCode: smsCode,
          password: this.$md5(password)
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$notify.success({
                title: '提示',
                message: response.data['message']
              })
              // 跳转到登录页
              this.handleToLogin()
              break
            }
            default: {
              this.$notify.error({
                title: '错误',
                message: response.data['message']
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error('用户注册信息提交失败')
      }).finally(() => {
        this.registerForm.committing = false
      })
    }
  },
  created () {
    this.loadRegisterData()
  },
  watch: {
    'registerVerification.delay': function (newVal, oldVal) {
      if (oldVal <= 0 && newVal > 0) {
        clearTimeout(this.registerVerification.timer)
        this.refreshSmsSendDelay()
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../styles/theme";
.home-main-left-register {
  padding-top: 30px;
  &>.register-form {
    &>.form-item {
      position: relative;
      margin-bottom: 10px;
      &.required {
        &>.form-label {
          &:before {
            content: '\002a';
            color: #f00;
            padding-right: 4px;
            vertical-align: -2px;
          }
        }
      }
      &>.form-label {
        font-size: 14px;
        text-align: right;
        float: left;
        width: 90px;
        padding-right: 10px;
        color: #666;
        line-height: 40px;
        white-space: nowrap;
        box-sizing: border-box;
      }
      &>.form-input {
        margin-left: 90px;
        position: relative;
        &.append {
          padding-right: 130px;
          &>.form-append {
            position: absolute;
            right: 0;
            top: 0;
            width: 120px;
            height: 40px;
          }
        }
        .form-icon {
          padding-right: 5px;
        }
      }
      .el-select {
        width: 100%;
      }
      .el-input {
        width: 100%;
        &>.el-input__inner {
          height: 40px;
          line-height: 18px;
          padding: 9px 15px;
        }
      }
      .el-button {
        height: 40px;
        width: 100%;
        &.send-verification-btn {
          color: $default-text-color;
          font-size: 14px;
          transition: none;
          background-color: $default-button-background-color;
          border-color: $default-button-background-color;
          &:active {
            background-color: darken($default-button-background-color, 5);
            border-color: darken($default-button-background-color, 5);
          }
        }
        &.submit-register-btn {
          font-size: 16px;
          letter-spacing: 3px;
        }
      }
      .el-radio-button__orig-radio:checked {
        &+.el-radio-button__inner {
          color: #FFF;
          background-color: $theme-primary-color;
          border-color: $theme-primary-color;
          box-shadow: -1px 0 0 0 $theme-primary-color;
        }
      }
      .el-radio-button__inner:hover{
        color: $theme-primary-color
      }
      .auth-img {
        position: relative;
        width: 100%;
        height: 40px;
        background: center no-repeat;
        border-radius: 3px;
        background-size: contain;
        box-sizing: border-box;
        cursor: pointer;
        overflow: hidden;
      }
      .hint-msg {
        margin-top: 5px;
        color: #999;
        font-size: 12px;
        letter-spacing: -0.5px;
      }
    }
  }
  &>.btn-group {
    margin-top: 20px;
    &>.el-button {
      width: 100%;
      height: 40px;
      &.submit-register-btn {
        font-size: 16px;
        letter-spacing: 3px;
      }
    }
  }
  &>.bottom-menu {
    margin-top: 15px;
    &>.forget-password,
    &>.login {
      a, span {
        color: $theme-primary-color;
        font-size: 14px;
        text-decoration: none;
        outline: none;
        font-weight: bold;
        cursor: pointer;
      }
    }
    &>.forget-password {
      float: left;
    }
    &>.login {
      float: right;
    }
  }
}

@media (max-width: 1052px) and  (min-width: 641px){
  .home-main-left-register {
    &>.register-form {
      &>.form-item {
        &>.form-label {
          line-height: 24px;
          text-align: left;
          float: none;
          width: 100%;
          color: #666;
          white-space: nowrap;
        }
        &>.form-input {
          margin-left: 0;
          &.append {
            padding-right: 94px;
            &>.form-append {
              position: absolute;
              right: 0;
              top: 0;
              width: 84px;
              height: 28px;
            }
          }
        }
        .el-input {
          width: 100%;
          & > .el-input__inner {
            height: 28px;
            line-height: 16px;
            padding: 5px 15px;
          }
        }
        .el-button {
          height: 28px;
          width: 84px;
          padding: 6px 10px;
          font-size: 12px;
          &.send-verification-btn {
            font-size: 12px;
          }
        }
        .auth-img {
          height: 28px;
          width: 84px;
        }
      }
    }
    &>.btn-group {
      &>.el-button {
        height: 28px;
        line-height: 16px;
        padding: 5px 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homeIndex/HomeMainLeftRegister.vue